import React from 'react';
import { ContactsManagement } from '../../components/contacts/ContactsManagement';

export const ContactsManagementPage: React.FC = () => {
  return (
    <ContactsManagement />
  );
};

export default ContactsManagementPage;
